import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth"

import { firebaseApp } from "../../util/firebase"
import { createJoonAPIClient } from "../../util/joon-api"
import { sessionManager } from "../../util/storage"
import { loadUser } from "../user/api"

export async function signin(email: string, password: string) {
  const API = createJoonAPIClient()
  return API.post("api/auth/signin/", { email: email, password: password })
}

export async function resetPassword(email: string) {
  const API = createJoonAPIClient()
  return API.post(`api/auth/reset-password/`, { email })
}

export async function createAuth({
  email,
  password,
}: {
  email: string
  password: string
}) {
  const API = createJoonAPIClient()
  return API.post(`api/auth/signup/`, {
    email,
    password,
  })
}

// Sign in with google, and return the refresh token
export function signInWithGoogle(): Promise<any> {
  const auth = getAuth(firebaseApp)
  const googleAuthProvider = new GoogleAuthProvider().setCustomParameters({
    prompt: "select_account",
  })
  return signInWithPopup(auth, googleAuthProvider)
    .then(async (response) => {
      const refreshToken = response.user.refreshToken
      sessionManager.storeTokens(refreshToken, null)

      const user = await loadUser()
      if (!user) throw new Error("User does not exist. Please sign up.")

      return new Promise((resolve) => resolve(refreshToken))
    })
    .catch((error) => {
      sessionManager.clearAuthTokens()
      throw error
    })
}
